









































import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator';
import { pageSizeItems } from '@/utils/constants';

// 分页条
@Component
export default class PageBar extends Vue {
  // 当前处于第几页
  @Prop() public page!: number;

  // 每页显示多少条数据
  @Prop() public size!: number;

  // 总共有多少条数据
  @Prop() public total!: number;

  // pageSize 下拉框数据
  @Prop() public items!: number[];

  // 是否显示 pageSize 下拉框
  @Prop({ type: Boolean, default: true }) public showSize!: boolean;

  // 是否显示'跳转到'输入框
  @Prop({ type: Boolean, default: true }) public showGoto!: boolean;

  // 是否显示'总数量'
  @Prop({ type: Boolean, default: true }) public showTotal!: boolean;

  // 分页条上，数字按钮最多显示几个
  @Prop({ type: [Number, String], default: 9 }) public count!: number;

  public pageSize = pageSizeItems[1];
  public pageNum = 1;
  public gotoNum = '';

  // 分页下拉框
  public get sizeItems() {
    return this.items || pageSizeItems;
  }

  // 总页数
  public get pageTotal() {
    return this.total ? Math.ceil(this.total / this.pageSize) : 0;
  }

  // 按回车键跳转到指定页数
  public onGotoNumKeydown(e: KeyboardEvent) {
    const el = (e.target as HTMLInputElement);
    let pageNum = Math.abs(parseInt(el.value, 10));
    pageNum = isNaN(pageNum) ? 1 : pageNum;
    pageNum = pageNum > this.pageTotal ? this.pageTotal : pageNum;
    this.gotoNum = pageNum.toString();
    this.pageNum = pageNum;
    el.select();
    this.$emit('change', { pageNum, pageSize: this.pageSize });
  }

  @Watch('page', { immediate: true })
  public onPageChange(value: number) {
    this.pageNum = value;
  }

  @Watch('size', { immediate: true })
  public onSizeChange(value: number) {
    this.pageSize = value;
  }

  @Emit('change')
  public onPageSizeChange(pageSize: number) {
    this.pageNum = 1;
    this.pageSize = pageSize;
    return { pageNum: 1, pageSize };
  }

  @Emit('change')
  public onPageNumChange(pageNum: number) {
    this.gotoNum = '';
    this.pageNum = pageNum;
    return { pageNum, pageSize: this.pageSize };
  }
}
